import React from 'react';
import { connect } from 'react-redux';
import { Button, Accordion } from 'react-bootstrap';
import moment from 'moment';
import Draggable from 'react-draggable';
import _ from 'lodash';

import { trackChartPointDetailsView } from '../../util/mixpanel';
import { isWhite } from '../../util/colors';
import { formatWorkDuration } from '../../util/dates';

import closeIcon from '../../assets/img/x.svg';
import DetailStats from './DetailStats';

export class CTADetailsAccordion extends React.Component {
  constructor(props) {
    super(props);

    if (props.test) {
      this.state = {
        show: true,
        data: props.data,
        position:{ x: 95, y: 112 }
      }
    } else {
      this.state = {
        show: false,
        data: {},
        position:{ x: 95, y: 112 }
      };
    }

    this.handleClose = this.handleClose.bind(this);
    this.handleStop = this.handleStop.bind(this);
  }

  componentDidMount() {
    if (!!this.props.data) {
      this.setState({
        show: true,
        data: this.props.data,
        position: this.state.position
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        show: true,
        data: this.props.data,
        position: this.state.position
      });
    }        
  }

  handleClose() {
    this.setState({
      show: false,
      data: {},
      position:{ x: 95, y: 112 }
    });

    trackChartPointDetailsView('cta', false);
    if (this.props.onClose) {
      this.props.onClose();
    }
  }  
  
  handleStop(e, data) {
    let correctedPosition = this.checkBoundsForPosition(data);    
    this.setState({
      position: correctedPosition
    });
  }

  renderDetail(d, y, bl, blockedTime, label, blockers, isLongest) {
    const ct = formatWorkDuration(d.cycleTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays);
    const blockedList = _.find(bl, { listId: d.listId });
    const showBlockerInfo = blockers !== false && blockedTime === 'all';

    return (
      <p key={y} className={`detail-stage ${isLongest ? 'detail-stage--main' : ''}`}>
        <span className="detail-stage-name">{label}{' '}{d.list}</span>{' '}
        <span className="detail-stage-value">
        {ct}
        {showBlockerInfo && !!blockedList && (
          <span className="detail-stage-blocked">
            {d.list} blocked time:{' '}
            {formatWorkDuration(blockedList.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
          </span>
        )}
        </span>
      </p>
    );
  }

  checkBoundsForPosition(position){   
    if (position && this.props.bounds && position.x > this.props.bounds.right){
      position.x = this.props.bounds.right;
    }
    if (position && this.props.bounds && position.x < this.props.bounds.left){
      position.x = this.props.bounds.left;
    }
    return position;
  }

  render() {
    const { show, data, position } = this.state;
    const { duration, points } = data;
    const { blockedTime, blockers } = this.props;
    const showBlockerInfo = blockers !== false;
    const label = showBlockerInfo && blockedTime == 'blocked' ? 'Blocked ' : '';
    
    let correctedPosition = this.checkBoundsForPosition(position);

    return (
      <Draggable defaultPosition={{ x: 95, y: 112 }} axis="both" bounds="parent" onStop={this.handleStop} position={correctedPosition}>
        {!show || !points ? (
          <div></div>
        ) : (
          <div id={this.props.id} className="box_white_shadow detailed_accordion">
            <div className='box_white_title mb-4'>
              <DetailStats stats={[{ label: 'Cycle time', value: duration }]} />
              <div className='right-actions'>
                <Button variant='secondary' size='sm' className="btn-action" onClick={this.handleClose}>
                  <img src={closeIcon} alt="close" />
                </Button>
              </div>
            </div>
            
            <Accordion>
              {points.map((point, i) => {
                let className = isWhite(point.color) ?'label_dot label_dot--white' :'label_dot';
                if (showBlockerInfo && !point.card.isBlocked && !!point.card.blockedTime) {
                  className = 'label_dot bordered';
                }
                return (
                  <Accordion.Item eventKey={i} key={i} activeKey={i === 0} className={showBlockerInfo && !!point.card.blockedTime && 'accordion-item-blocked-card'}>
                    <Accordion.Header>
                      <span className={className} style={{ background: point.color }}></span>
                      {point.card.name}
                    </Accordion.Header>
                    <Accordion.Body>
                      {!!point.card.secondaryName && <p className="detail-summary">{point.card.secondaryName}</p>}
                      {!!point.date && <p key="date"><span className="detail-label">Start date:</span>{' '}<span className="detail-value">{moment(point.date).format(this.props.dateFormat)}</span></p>}
                      {!!point.details.length && (
                        <p className="detail-meta">
                          {!!point.card.coloredField && <span>{point.card.coloredValue}</span>}
                          <span>{label ? `${label}Cycle time: ` : ''}{formatWorkDuration(_.sumBy(point.details, 'cycleTime'), this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}</span>
                        </p>
                      )}
                      {showBlockerInfo && blockedTime === 'all' && !!point.card.blockedTime && (
                        <p className='block-item'>
                          <span className="detail-label">Blocked time:</span>{' '}<span className="detail-value">{formatWorkDuration(point.card.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}</span>
                        </p>
                      )}
                      {point.details.map((d, y) => {
                        return this.renderDetail(d, y, point.card.blockedLists, blockedTime, label, blockers, d === _.maxBy(point.details, 'cycleTime'));
                      })}
                      {!!point.card.url && (
                        <p>
                          <a href={point.card.url} target="_blank" className='btn btn-sm btn-light-secondary'>
                            Open in {this.props.app !== 'file' ? this.props.appName : 'new tab'}
                          </a>
                        </p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        )}
      </Draggable>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    appName: state.app.appName,
    timePrecision: state.filters.timePrecision,
    dateFormat: state.filters.dateFormat,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps)(CTADetailsAccordion);
